import { Link } from "gatsby";
import * as React from "react";
import { default as calculatorIcon } from "../../images/calculator.svg";
import { default as calendarIcon } from "../../images/calendar-calculator.svg";
import { default as heightIcon } from "../../images/height.svg";
import { default as suppositoriesIcon } from "../../images/suppositories.svg";
import { default as syrupIcon } from "../../images/syrup.svg";
import { Layout, PageIntro } from "../../components";
import { PageCategory, Tag } from "../../core/types";
import ReactSVG from "src/components/ReactSVG";
import { Container } from "@chakra-ui/react";

interface IProps {
  pageContext: {
    categories: PageCategory[];
    tags: Tag[];
  };
}

const mainCalculators = [
  {
    title: "objętości syropu przeciwgorączkowego",
    icon: syrupIcon,
    path: "/kalkulatory/objetosc-syropu-przeciwgoraczkowego",
    c2a: "Policz teraz!",
  },
  {
    title: "dawki czopków przeciwgorączkowych",
    icon: suppositoriesIcon,
    path: "/kalkulatory/czopki",
    c2a: "Sprawdź dawkę",
  },
];

const otherCalculators = [
  {
    title: "cyklu dla dziewczynek",
    icon: calendarIcon,
    path: "/kalkulatory/cykl-dla-dziewczynek",
  },
  {
    title: "przewidywanego wzrostu dziecka",
    icon: heightIcon,
    path: "/kalkulatory/przewidywany-wzrost-dziecka",
  },
];

export const Calculators: React.FC<IProps> = ({
  pageContext: { categories, tags },
}) => {
  // const isBigScreen = useMediaQuery({ query: "(min-width: 1024px)" });
  return (
    <Layout
      metaTitle="Kalkulatory"
      metaType="article"
      categories={categories}
      tags={tags}
    >
      <Container maxW="1100px" py={{ base: "0", sm: "47px"}}>
        <PageIntro
          title="Kalkulatory"
          content="Sprawdź szybko i łatwo poprawną objętość syropu przeciwgorączkowego dla swojego dziecka lub ustal poprawne dawkowanie czopków. Skorzystaj z naszych kalkulatorów."
          iconPath={calculatorIcon}
        />
        <div className="py-10">
          <div className="md:flex md:space-x-8 md:justify-stretch">
            {mainCalculators.map(({ title, icon, path, c2a }, i) => (
              <Link key={path} to={path} className="md:flex-grow">
                <div className="shadow-2 mb-4 py-3 px-5 md:pt-10 md:px-8 md:pb-5 flex space-x-3 md:space-x-6 items-center rounded-sm">
                  <div className="rounded-full bg-blue-3 w-20 md:w-32 h-20 md:h-32 flex-shrink-0 flex justify-center items-center">
                    <ReactSVG className="w-11 md:w-14" path={icon} />
                  </div>
                  <div>
                    <div className="text-xs md:text-m leading-4 md:leading-normal mb-3">
                      <span className="font-semibold">Kalkulator </span>
                      <span className="font-extrabold">{title}</span>
                    </div>
                    <div className="font-extrabold text-xxxs mb-1 md:mb-2 text-blue md:text-base">
                      {c2a}
                    </div>
                    <div className="bg-blue-3 h-0.5 md:h-1 w-4 md:w-7" />
                  </div>
                </div>
              </Link>
            ))}
          </div>
          <h3 className="text-s md:text-xl mt-9 md:mt-20 font-bold mb-4 md:mb-6">
            Sprawdź również:
          </h3>
          <div className="md:flex md:space-x-6">
            {otherCalculators.map(({ title, icon, path }, i) => (
              <Link key={path} to={path}>
                <div className="mb-4 flex space-x-3 md:space-x-5 items-center rounded-sm">
                  <div className="rounded-full bg-blue-3 w-10 md:w-14 h-10 md:h-14 flex-shrink-0 flex justify-center items-center">
                    <ReactSVG className="w-5 md:w-7" path={icon} />
                  </div>
                  <div>
                    <div className="text-xs md:text-s leading-4 md:text-grey-9">
                      <span className="font-semibold">Kalkulator </span>
                      <span className="font-extrabold">{title}</span>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </Container>
    </Layout>
  );
};
export default Calculators;
